// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  color: white;
  font-family: 'Cascadia Code', sans-serif;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.main_page {
  height: calc(100% - 4rem);
  width: 100%;
  scrollbar-width: thin;
  scrollbar-color: blue rgb(0, 0, 0);
  margin: 0 auto 0 auto;
  max-width: 1820px;
}

.flex {
  display: flex;
}

input {
  border: 2px solid white;
  background-color: transparent;
  color: white;
  border-radius: 3px;
  padding: 3px 3px 5px 5px;
  margin: 5px;
}

button {
  border: 2px solid white;
  background-color: transparent;
  color: white;
  border-radius: 3px;
  padding: 3px 3px 5px 5px;
  margin: 5px;
}

button:hover {
  background-color: white;
  color: black;
}

.v-stack {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.h-stack {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.login-popup {
  background-color: rgba(206, 124, 0, 0.4); /* Border color */
  border: 3px solid rgb(206, 134, 0);
  border-radius: 5px;
  margin-right: 5px;
  position: absolute;
  height: 10rem;
  top: calc(45vh - 5rem);
  left: calc(50vw - 15rem);
  width: 30rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 1s;
}

.login-popup[type="error"] {
  background-color: rgb(109, 0, 0, 0.4);
  border: 3px solid red;
}
.login-popup[type="ok"] {
  background-color: rgba(15, 109, 0, 0.4);
  border: 3px solid rgb(0, 255, 13);
}

.login_success {
  background-color: rgba(172, 255, 47, 0.375) !important;
  border-color: rgb(167, 253, 39) !important;
  transition: all 0.5s;
}

.login_failed {
  background-color: rgba(255, 47, 47, 0.412) !important;
  border-color: rgb(255, 47, 47) !important;
  transition: all 0.5s;
}

.text {
  white-space: pre-wrap;
  padding: 1rem;
  height: 100%;
  overflow-y: scroll;
}

.fallback {
  display: none;
}
.fallback-if-empty .fallback:only-child {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,kCAAkC;EAClC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wCAAwC,EAAE,iBAAiB;EAC3D,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;AACA;EACE,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,sDAAsD;EACtD,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB","sourcesContent":[".app {\r\n  color: white;\r\n  font-family: 'Cascadia Code', sans-serif;\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  overflow-x: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.main_page {\r\n  height: calc(100% - 4rem);\r\n  width: 100%;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: blue rgb(0, 0, 0);\r\n  margin: 0 auto 0 auto;\r\n  max-width: 1820px;\r\n}\r\n\r\n.flex {\r\n  display: flex;\r\n}\r\n\r\ninput {\r\n  border: 2px solid white;\r\n  background-color: transparent;\r\n  color: white;\r\n  border-radius: 3px;\r\n  padding: 3px 3px 5px 5px;\r\n  margin: 5px;\r\n}\r\n\r\nbutton {\r\n  border: 2px solid white;\r\n  background-color: transparent;\r\n  color: white;\r\n  border-radius: 3px;\r\n  padding: 3px 3px 5px 5px;\r\n  margin: 5px;\r\n}\r\n\r\nbutton:hover {\r\n  background-color: white;\r\n  color: black;\r\n}\r\n\r\n.v-stack {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n}\r\n\r\n.h-stack {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-grow: 1;\r\n}\r\n\r\n.login-popup {\r\n  background-color: rgba(206, 124, 0, 0.4); /* Border color */\r\n  border: 3px solid rgb(206, 134, 0);\r\n  border-radius: 5px;\r\n  margin-right: 5px;\r\n  position: absolute;\r\n  height: 10rem;\r\n  top: calc(45vh - 5rem);\r\n  left: calc(50vw - 15rem);\r\n  width: 30rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  transition: 1s;\r\n}\r\n\r\n.login-popup[type=\"error\"] {\r\n  background-color: rgb(109, 0, 0, 0.4);\r\n  border: 3px solid red;\r\n}\r\n.login-popup[type=\"ok\"] {\r\n  background-color: rgba(15, 109, 0, 0.4);\r\n  border: 3px solid rgb(0, 255, 13);\r\n}\r\n\r\n.login_success {\r\n  background-color: rgba(172, 255, 47, 0.375) !important;\r\n  border-color: rgb(167, 253, 39) !important;\r\n  transition: all 0.5s;\r\n}\r\n\r\n.login_failed {\r\n  background-color: rgba(255, 47, 47, 0.412) !important;\r\n  border-color: rgb(255, 47, 47) !important;\r\n  transition: all 0.5s;\r\n}\r\n\r\n.text {\r\n  white-space: pre-wrap;\r\n  padding: 1rem;\r\n  height: 100%;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.fallback {\r\n  display: none;\r\n}\r\n.fallback-if-empty .fallback:only-child {\r\n  display: block;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
